<script>
    export let categoryName = 'more';
    export let image = '';
    export let imageCaption = '';
    let borderRadius ='1rem';
</script>

<style>
    .category{
        position: relative;
        display: inline-block;
        width: 100%;
        height: 12rem;
        background-color: #999999;
        border-radius: var(--border-radius);
        color: #FFFFFF;
        box-sizing: border-box;
        box-shadow: 0px 0px 5px 0px rgba(221,221,221,1);
    }

    .category__image{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: var(--border-radius);
    }

    .category__name{
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 1.5rem 0 ;
        font-size: 1.1rem;
        background-image: linear-gradient(transparent, black);
        text-align: center;
        border-bottom-left-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
    }

</style>

<a class='category' href='#view-category' style='--border-radius: {borderRadius};'>
    <img src={image} class='category__image' alt={imageCaption}>
    <span class='category__name'><span>{categoryName}</span></span>
</a>
